import React from 'react';
import { ConsentForm } from './view/consentForm';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'ConsentForm', 
  itemElt: (item, cmsOption) => <ConsentForm item={item} cmsOption={cmsOption} />
}